module.exports = __webpack_public_path__ + "static/media/intellitec-logo.28477a74.png";